import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

const initialState = false;

const slice = createSlice({
  name: 'loyaltyHeaders',
  initialState,
  reducers: {
    showLoyaltyHeaders(state, action: PayloadAction<boolean>) {
      return action.payload || initialState;
    },
  },
});

export const { showLoyaltyHeaders } = slice.actions;

export default slice.reducer;
